import type { AcquisitionFilter } from "../../EnergyDataView";
import type { EdaFilterOptions } from "../EnergyDataAcquisitionSelectionModal";

/** When only one site exists and no site is pre-selected, auto-select it. */
export function applySitePreselection(
  filters: Array<AcquisitionFilter>,
  filterOptions?: Record<string, EdaFilterOptions>
): Array<AcquisitionFilter> {
  if (filterOptions?.sites?.length !== 1) return filters;

  return filters.map((f) =>
    f.type === "sites" && f.options.length === 1 && f.options[0] === ""
      ? { ...f, options: [filterOptions.sites[0].value.toString()] }
      : f
  );
}
